import customSelect from 'custom-select';
const runCustomSelect = () => {
    const allSelect = document.querySelectorAll('select');
    Array.from(allSelect).forEach((singleSelect) => {
        if (singleSelect.classList.contains('no-custom-select')) {}
        else 
        customSelect(singleSelect);
    });
}


export default runCustomSelect;
